var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFirstTaskBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 386,
    height: 101,
    viewBox: "0 0 386 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M384.766 19.8252H1.49268V99.6943H384.766V19.8252Z",
    fill: "url(#paint0_linear_5010_550)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M384.766 19.8252H1.49268V99.6943H384.766V19.8252Z",
    fill: "#FF5733",
    fillOpacity: 0.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M385.978 100.906H0V23.8746H385.978V100.906ZM1.47768 99.702H384.5V25.0857H1.47768V99.702Z",
    fill: "#BD2333"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 24.9414V0H196.502L214.751 14.9485H386V24.9414H0Z",
    fill: "#BD2333"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M252.44 9.04635H218.985L209.292 1H259.193L252.44 9.04635ZM219.539 7.96161H251.745L256.673 2.08473H212.461L219.539 7.96161Z",
    fill: "#BD2333"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M313.35 1.1709H303.028L296.563 8.88291H306.885L313.35 1.1709Z",
    fill: "#BD2333"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M260.597 8.88291H270.918L277.383 1.1709H267.062L260.597 8.88291Z",
    fill: "#BD2333"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M331.333 1.1709H321.012L314.547 8.88291H324.868L331.333 1.1709Z",
    fill: "#BD2333"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M295.367 1.1709H285.045L278.58 8.88291H288.902L295.367 1.1709Z",
    fill: "#BD2333"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M369.191 1.1709H358.87L352.405 8.88291H362.726L369.191 1.1709Z",
    fill: "#BD2333"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M350.735 1.1709H340.414L333.949 8.88291H344.27L350.735 1.1709Z",
    fill: "#BD2333"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M377.725 1.1709L371.253 8.88291H386V1.1709H377.725Z",
    fill: "#BD2333"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5010_550",
    x1: 193.133,
    y1: -28.7947,
    x2: 193.133,
    y2: 136.464,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BD2333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFirstTaskBg);
export default __webpack_public_path__ + "static/media/iconFirstTaskBG.69bc380c1aedd9e2f4e7c26816a3a3b4.svg";
export { ForwardRef as ReactComponent };